import React from 'react';

import Link from '../Link/Link';

import './ImageThumbnail.scss';

const ImageThumbnail = ({ image, url, onClick, discountTagsVersion }) => {
  const handleOnClick = () => {
    if (onClick) {
      onClick();
    }
  };
  return (
    <div
      className="image-thumbnail"
      style={
        {
          // padding: discountTagsVersion === 2 ? '15px 15px 0' : '15px 25px 0',
        }
      }
    >
      <Link to={url} onClick={handleOnClick}>
        <div
          className="image-container"
          style={{ backgroundImage: `url(${image})` }}
        ></div>
      </Link>
    </div>
  );
};

export default ImageThumbnail;
